/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

const SERVICE_BASE = 'https://ftms-demo-api.herokuapp.com/';
const SERVICE_BASE_WS = 'wss://ftms-demo-api.herokuapp.com/';
const SERVICE_BASE_AUTH = 'https://ftms-demo-auth.herokuapp.com/';
declare var require: any;

export const environment = {
  production: true,
  // Version
  VERSION: require('../../package.json').version,
  // Authorization
  auth_http_basic_auth: 'c2VydmljZS1hY2NvdW50LTE6Q3NpUU9RbDdLR1JVckxrZWJpZkQ=',
  auth_grant_type: 'password',
  auth_token_endpoint: SERVICE_BASE_AUTH + 'auth/oauth/token',
  // Registration
  security_http_basic_auth: 'c2VjdXJpdHktYWNjb3VudC0xOmo3eTdVeXIzcUZPd1F5NDRvdHpB',
  security_grant_type: 'client_credentials',
  // Services
  service_base: SERVICE_BASE,
  service_security_registration: SERVICE_BASE + 'security/registration',
  service_security_request_password: SERVICE_BASE + 'security/request-password',
  service_security_reset_password: SERVICE_BASE + 'security/reset-password',
  service_security_username: SERVICE_BASE + 'security/username',
  service_security_usernamexxx: SERVICE_BASE + 'security/usernamexxx',
  service_users_change_password: SERVICE_BASE + 'users/change-password',
  service_serialnumber_count: SERVICE_BASE + 'serialnumbers/serialnumber/count',
  service_serialnumber: SERVICE_BASE + 'serialnumbers/serialnumber',
  service_serialnumberdetail: SERVICE_BASE + 'serialnumbers/serialnumber/detail',
  service_serialnumber_smart: SERVICE_BASE + 'serialnumbers/serialnumber-smart',
  service_serialnumberbatch_count: SERVICE_BASE + 'serialnumberbatchs/serialnumberbatch/count',
  service_serialnumberbatch: SERVICE_BASE + 'serialnumberbatchs/serialnumberbatch',
  service_serialnumberbatch_smart: SERVICE_BASE + 'serialnumberbatchs/serialnumberbatch-smart',
  service_serialnumberlot: SERVICE_BASE + 'serialnumberlots/serialnumberlot',
  service_serialnumberlot_shipping: SERVICE_BASE + 'serialnumberlots/serialnumberlot/shipping',
  service_serialnumberlot_smart: SERVICE_BASE + 'serialnumberlots/serialnumberlot-smart',
  service_product_count: SERVICE_BASE + 'products/product/count',
  service_product_smart: SERVICE_BASE + 'products/product-smart',
  service_product_simple: SERVICE_BASE + 'products/simple',
  service_product: SERVICE_BASE + 'products/product',
  service_provider_smart: SERVICE_BASE + 'providers/provider-smart',
  service_provider: SERVICE_BASE + 'providers/provider',
  service_cmo_count: SERVICE_BASE + 'cmos/cmo/count',
  service_cmo_smart: SERVICE_BASE + 'cmos/cmo-smart',
  service_cmo: SERVICE_BASE + 'cmos/cmo',
  service_company_text: SERVICE_BASE + 'company/text',
  service_company_logo: SERVICE_BASE + 'company/logo',
  service_company_url: SERVICE_BASE + 'company/url',
  service_company_year: SERVICE_BASE + 'company/year',
  service_company_data: SERVICE_BASE + 'company/data',
  service_wholesaler_smart: SERVICE_BASE + 'wholesalers/wholesaler-smart',
  service_wholesaler: SERVICE_BASE + 'wholesalers/wholesaler',
  service_serialnumberrequest: SERVICE_BASE + 'serialnumberrequests/serialnumberrequest',
  service_serialnumberrequest_smart: SERVICE_BASE + 'serialnumberrequests/serialnumberrequest-smart',
  service_serialnumberresponse: SERVICE_BASE + 'serialnumberresponses/serialnumberresponse',
  service_serialnumberresponse_smart: SERVICE_BASE + 'serialnumberresponses/serialnumberresponse-smart',
  service_serialnumbershippingevent: SERVICE_BASE + 'serialnumbershippingevents/serialnumbershippingevent',
  service_serialnumbershippingeventconfirmation: SERVICE_BASE + 'serialnumbershippingevents/serialnumbershippingeventconfirmation',
  service_serialnumbershippingevent_generate: SERVICE_BASE + 'serialnumbershippingevents/generate',
  service_serialnumbershippingevent_smart: SERVICE_BASE + 'serialnumbershippingevents/serialnumbershippingevent-smart',
  service_configuration: SERVICE_BASE + 'configuration/configuration',
  service_emvo: SERVICE_BASE + 'emvo/emvo',
  service_emvo_smart: SERVICE_BASE + 'emvo/emvo-smart',
  service_emvo_all_enum: SERVICE_BASE + 'emvo/all-enum',
  service_emvo_master_data: SERVICE_BASE + 'emvo/master-data',
  service_stomp_push: SERVICE_BASE_WS + 'stomp/push',
  service_dashboard_generated_sns_distribution: SERVICE_BASE + 'dashboard/generated-sns-distribution',
  service_dashboard_activities: SERVICE_BASE + 'dashboard/activities',
  service_dashboard_outstanding: SERVICE_BASE + 'dashboard/outstanding',
  service_dashboard_snpools: SERVICE_BASE + 'dashboard/snpools',
  service_dashboard_sns_per_product: SERVICE_BASE + 'dashboard/sns-per-product',
  service_dashboard_sns_per_product_2: SERVICE_BASE + 'dashboard/sns-per-product-2',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts